import { Spin } from 'antd';
import { ParallelChart } from '@components/charts';
import { useWidgetData } from '@hooks/useWidgetData';
import type { WidgetDefinition, WidgetRenderProps } from '@/types';

interface Data {
  dimensions: Array<{ name: string; min: number; max: number }>;
  data: number[][];
}

function ParallelWidget({ instance }: WidgetRenderProps) {
  const { data, isLoading } = useWidgetData<Data>(
    instance.id, 'parallel', instance.config as Record<string, unknown>, instance.refreshInterval,
  );
  if (isLoading) return <Spin />;
  return <ParallelChart dimensions={data?.dimensions ?? []} data={data?.data ?? []} />;
}

export const parallelWidgetDef: WidgetDefinition = {
  type: 'parallel',
  name: 'Parallel Coordinates',
  description: 'Multi-dimension comparison',
  icon: 'DashboardOutlined',
  category: 'chart',
  defaultTitle: 'Parallel Coordinates',
  defaultConfig: {},
  minW: 4, minH: 4, defaultW: 6, defaultH: 6,
  component: ParallelWidget,
  settingsSchema: { fields: [] },
};
